import Task, { AzfTaskModel as AzfTask } from "./TaskModel"
import { getCurrentApp } from "app/api/localTools"

/*
 * manager in entrance
 */
export default class {
  tasks = {}
  currentTaskId = ""

  addTask = ({id, allowSuffix}) => {
    if (!this.tasks[id]) {
      this.tasks[id] = getCurrentApp() === "azf"
        ? new AzfTask(id, allowSuffix)
        : new Task(id, allowSuffix)
    }
    this.currentTaskId = id
  }

  clearTasks = () => {
    this.tasks = {}
  }

  get currentTask () {
    return this.tasks[this.currentTaskId]
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/BasicModal/UploadModal/stores/manager.js